import { type TransformNode } from '@babylonjs/core/Meshes/transformNode';
import { type AssetContainer } from '@babylonjs/core/assetContainer';
import { type Scene as BabylonScene } from '@babylonjs/core/scene';
import { type Nullable } from '@babylonjs/core/types';
import { type IScene, type ISceneEntity } from '@seddi/scene';
import * as Scene from '../scene/scene';
import * as SceneModule from '../scene/sceneModule';
import { SeamRenderable } from '../renderables/seamRenderable';
import { StitchUtils } from './utils/stitchUtils';
import { type StitchLoader } from './stitchLoader';

export class EcSeamLoader {
  private readonly babylonScene: BabylonScene;
  private readonly stitchLoader: StitchLoader;

  private _assetContainer: Nullable<AssetContainer> = null;

  constructor(babylonScene: BabylonScene, stitchLoader: StitchLoader) {
    this.babylonScene = babylonScene;
    this.stitchLoader = stitchLoader;
  }

  // eslint-disable-next-line @typescript-eslint/require-await -- Todo
  async loadAssetContainerAsync(
    scene: IScene,
    entity: ISceneEntity,
    parent: TransformNode,
    container: Nullable<AssetContainer> = null,
  ): Promise<SeamRenderable> {
    this._assetContainer = container;
    return this._loadAsync(scene, entity, parent);
  }

  loadAsync(scene: IScene, entity: ISceneEntity, parent: TransformNode): SeamRenderable {
    return this._loadAsync(scene, entity, parent);
  }

  _loadAsync(scene: IScene, entity: ISceneEntity, parent: TransformNode): SeamRenderable {
    const renderable = new SeamRenderable(entity._id, this.babylonScene);

    const hasGeometry = Scene.hasGeometrySurface(scene);
    if (!hasGeometry) {
      return renderable;
    }

    const component = entity.components.garmentSeam!;
    const { process } = component;
    const garmentGeometry = SceneModule.sceneExt.garmentGeometry!;
    const { id, stitches } = garmentGeometry.seams.find(s => s.id === entity._id)!;

    for (const stitch of stitches) {
      const { name } = stitch;
      const color = StitchUtils.GetThreadColor(stitch, process);
      this.stitchLoader.loadAssetContainer(
        `${id}-${name}`,
        stitch,
        color,
        parent,
        this._assetContainer,
      );
    }

    return renderable;
  }
}
